import gql from 'graphql-tag';

export default gql`
  mutation CreateStakeholder(
    $firstName: String!
    $lastName: String!
    $dob: DateTime!
    $country: String!
    $homeNumber: String!
    $cellNumber: String!
    $email: String!
    $idNumber: String!
    $residentialAddress: String!
    $postalAddress: String!
    $status: StakeholderStatus!
    $role: StakeholderRole!
  ) {
    createStakeholder(
      data: {
        firstName: $firstName
        lastName: $lastName
        dob: $dob
        country: $country
        homeNumber: $homeNumber
        cellNumber: $cellNumber
        email: $email
        idNumber: $idNumber
        residentialAddress: $residentialAddress
        postalAddress: $postalAddress
        status: $status
        role: $role
      }
    ) {
      createdAt
      updatedAt
      id
      firstName
      lastName
      dob
      country
      cellNumber
      email
      idNumber
      residentialAddress
      postalAddress
      status
      role
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateStakeholder.ts